import { DragDropContext } from 'react-beautiful-dnd';

import DroppableBlank from './DroppableBlank';

interface FillBlankProps {
  blanksOrder: Array<string>;
  onAnswer: (v: any) => void;
  options: any;
  data: any;
  isSubmitted: boolean;
  display?: boolean;
}

export function FillBlank({
  blanksOrder,
  onAnswer,
  options,
  isSubmitted,
  display,
  data,
}: FillBlankProps) {
  const blanks = data;

  // id for word bank is b-0
  const wordBankItems = blanks['b-0'].itemIds.map((id: string) => options[id]);

  const onDragEnd = (dragResult: any) => {
    const { destination, source, draggableId } = dragResult;

    if (!destination) {
      return;
    }
    // no re-ordering within same column
    if (destination.droppableId === source.droppableId) {
      return;
    }

    // if a blank already has 1 item, swap!!! can only ever be 1 item in a blank (except for "b-0" -- the word bank box)
    if (
      blanks[destination.droppableId].itemIds.length > 0 &&
      destination.droppableId !== 'b-0'
    ) {
      const newDestinationBlank = {
        ...blanks[destination.droppableId],
        itemIds: [draggableId],
        status: '',
      };

      // remove the item being dragged and add what was previously in the destination
      const newSourceBlank = {
        ...blanks[source.droppableId],
        itemIds: [
          ...blanks[source.droppableId].itemIds.filter(
            (id: string) => id !== draggableId
          ),
          ...blanks[destination.droppableId].itemIds,
        ],
        status: '',
      };

      const newBlanksState = {
        ...blanks,
        [destination.droppableId]: newDestinationBlank,
        [source.droppableId]: newSourceBlank,
      };

      onAnswer(Object.values(newBlanksState));

      return;
    }

    // if there is nothing in that blank, update accordingly
    const newDestinationBlank = {
      ...blanks[destination.droppableId],
      itemIds: [...blanks[destination.droppableId].itemIds, draggableId],
      status: '',
    };

    const newSourceBlank = {
      ...blanks[source.droppableId],
      itemIds: blanks[source.droppableId].itemIds.filter(
        (id: string) => id !== draggableId
      ),
      status: '',
    };

    const newBlanksState = {
      ...blanks,
      [destination.droppableId]: newDestinationBlank,
      [source.droppableId]: newSourceBlank,
    };

    onAnswer(Object.values(newBlanksState));
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div className="my-4 rounded-md w-full">
        <DroppableBlank
          key={blanks['b-0'].id}
          items={wordBankItems}
          blank={blanks['b-0']}
        />

        <div className={'mt-2'}>
          {blanksOrder.map((blankId: string, index: number) => {
            const blank = blanks[blankId];
            const items = blank.itemIds?.map(
              (itemId: string) => options[itemId]
            );

            return (
              <DroppableBlank
                key={blankId}
                items={items}
                blank={blank}
                show={blanksOrder.length !== index + 1 ? 'y' : 'n'}
                status={`${
                  isSubmitted ? (display ? 'correct' : 'wrong') : 'default'
                }`}
              />
            );
          })}
        </div>
      </div>
    </DragDropContext>
  );
}
